import { registerEnumSet } from '@if/mui'
import { ESystemFlowMode } from '@src/types/dev-tools'
import { Database, Landmark } from 'lucide-react'

export const ESystemFlowModeSet = {
  Event: `${ESystemFlowMode.Event}`,
  Master: `${ESystemFlowMode.Master}`,
} as const

export type ESystemFlowModeValue = (typeof ESystemFlowModeSet)[keyof typeof ESystemFlowModeSet]

export const toSystemFlowModeValue = (mode: ESystemFlowMode): ESystemFlowModeValue =>
  String(mode) as ESystemFlowModeValue

registerEnumSet(ESystemFlowModeSet, {
  [ESystemFlowModeSet.Event]: {
    color: 'warning',
    icon: Landmark,
    labelKey: 'admin.devTools.systemFlowModes.modes.event',
  },
  [ESystemFlowModeSet.Master]: {
    color: 'success',
    icon: Database,
    labelKey: 'admin.devTools.systemFlowModes.modes.master',
  },
})
